import { Spinner, Surface } from '@vst/beam';
import { useTranslation } from 'react-i18next';

export const CalendarLoading = () => {
  const { t } = useTranslation('ScheduleInstallation');
  return (
    <Surface mb="48px">
      <Spinner description={t('calendar.loading')} />
    </Surface>
  );
};
